import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=30bba8fb&scoped=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=30bba8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bba8fb",
  null
  
)

export default component.exports